module.exports = __webpack_public_path__ + "img/icon-account-branch-finder-green@3x.eb55c98e.png";